import Text from "@afa-shared/afa-components/dist/Text";
import Message from "@components/Message/Message";

const FormSendError = () => {
  return (
    <Message
      heading={"Ett fel har inträffat"}
      headingVariant={"h2"}
      type={"error"}
      live="assertive"
      children={
        <>
          <Text
            variant="paragraph"
            children={
              "Vi kunde inte skicka iväg ditt meddelande på grund av att ett tekniskt fel har inträffat. Var vänlig försök igen senare."
            }
          />
        </>
      }
    />
  );
};

export default FormSendError;
